import { render, staticRenderFns } from "./CostGuardNotice.vue?vue&type=template&id=a73375a2&scoped=true&"
import script from "./CostGuardNotice.vue?vue&type=script&lang=ts&"
export * from "./CostGuardNotice.vue?vue&type=script&lang=ts&"
import style0 from "./CostGuardNotice.vue?vue&type=style&index=0&id=a73375a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73375a2",
  null
  
)

export default component.exports